module.exports = __webpack_public_path__ + "static/media/writegirl.a1cd48a2.md";